import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { RmService } from '../../../services/rm/rm.service';
import { ApiServiceService } from '../../../services/common/api-service.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-rm-dashboard',
  templateUrl: './rm-dashboard.component.html',
  styleUrls: ['./rm-dashboard.component.scss']
})
export class RmDashboardComponent implements OnInit, OnDestroy {
  rmUser: any = null;
  loading = true;
  stats: any = {
    assigned_clients: 0,
    pending_replies: 0,
    tasks_today: 0,
    meetings: 0,
    new_express_subscribers: 0
  };
  clients: any[] = [];
  filteredClients: any[] = [];
  clientPhotos: { [id: string]: string } = {};
  searchTerm = '';
  selectedStageFilter = 'All';

  stages = [
    'All',
    'Searching',
    'Profiles Shared',
    'Interest Sent',
    'Interest Accepted',
    'Parents Connected',
    'Meeting Scheduled',
    'Engagement',
    'Married'
  ];

  private userSub!: Subscription;

  constructor(private rmService: RmService, private router: Router, private apiService: ApiServiceService) {}

  ngOnInit(): void {
    this.userSub = this.rmService.getRmUser$().subscribe(u => {
      this.rmUser = u;
    });
    this.loadDashboardData();
  }

  ngOnDestroy(): void {
    if (this.userSub) this.userSub.unsubscribe();
  }

  loadDashboardData(): void {
    this.loading = true;
    this.rmService.getDashboardStats().subscribe({
      next: res => {
        this.loading = false;
        if (res.status === 'success') {
          this.stats = res.data.stats;
          this.clients = res.data.clients || [];
          this.filterClients();
          this.loadClientPhotos();
        }
      },
      error: err => {
        this.loading = false;
        console.error('Error loading RM dashboard stats:', err);
      }
    });
  }

  loadClientPhotos(): void {
    this.clients.forEach(client => {
      if (client._id && client.photo && !this.clientPhotos[client._id]) {
        const photoPath = client.photo;
        // If it's already a full URL, use directly
        if (photoPath.startsWith('http') || photoPath.startsWith('data:')) {
          this.clientPhotos[client._id] = photoPath;
        } else {
          // Load via base64 proxy (avatar_Id is a MinIO/S3 key path)
          this.apiService.getImageBase64(photoPath).subscribe({
            next: (data) => {
              if (data && data.base64Image) {
                this.clientPhotos[client._id] = 'data:image/jpeg;base64,' + data.base64Image;
              }
            },
            error: () => {}
          });
        }
      }
    });
  }

  filterClients(): void {
    this.filteredClients = this.clients.filter(c => {
      const matchesSearch = !this.searchTerm ||
        c.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        c.phone.toLowerCase().includes(this.searchTerm.toLowerCase());
      const matchesStage = this.selectedStageFilter === 'All' || c.current_stage === this.selectedStageFilter;
      return matchesSearch && matchesStage;
    });
  }

  openClientWorkspace(clientId: string): void {
    this.router.navigate(['/rm/client', clientId]);
  }

  openSearch(): void {
    this.router.navigate(['/rm/search']);
  }

  logout(): void {
    this.rmService.logout();
    this.router.navigate(['/rm/login']);
  }
}
